module.exports = __webpack_public_path__ + "img/详情.40dc8462.svg";